import { mutate } from "swr";

const { VITE_CATALOG_API } = import.meta.env;
const DATASETS_API_PREFIX = `${VITE_CATALOG_API}/datasets`;

/**
 * The full catalog dataset list the nextgen project UI reads to resolve a
 * project's attached dataset ids to display records. Exported as a single
 * source of truth so SWR cache revalidations key-match the fetch exactly —
 * a mismatch would silently fail to refresh.
 */
export const catalogDatasetsListUrl = `${DATASETS_API_PREFIX}?offset=0&limit=1000&sort_by=title&sort_order=asc`;

/** Revalidate every cached dataset-list key (the nextgen list page's own sort/offset
 *  variants, plus `catalogDatasetsListUrl`) — a bare per-dataset `mutate()` leaves
 *  list/card views stale after an edit since they're cached under a separate key. */
export const mutateDatasetList = () =>
  mutate((key) => typeof key === "string" && key.startsWith(`${DATASETS_API_PREFIX}?`));
